<template>
  <ui-component-modal
    :modalTitle="$t('Views.Settings.ModalEditExportGroup.Main_Title')"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="editExportgroup"
    :disableSaveButton="nameErrors.length > 0"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <div class="field">
        <div class="control">
          <ui-base-input-field
            v-model="mExportGroup.Name"
            :error=" nameErrors"
            :required="true"
            :label="$t('Views.Settings.ModalEditExportGroup.Label_Name')"
            fieldType="text"
            v-on:keyup.enter="editExportgroup()"
            @input="$v.mExportGroup.Name.$touch()"
            @blur="$v.mExportGroup.Name.$touch()"
          />
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import exportgroupProvider from '@/providers/exportgroup.js'
import { required, minLength } from 'vuelidate/lib/validators'

const touchMap = new WeakMap()


export default {
  components: {
  },
  props: {
    exportgroup: null,

    showModal: {
      type: Boolean,
      default: false
    },

    onClickCancel: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mExportGroup: {},
    }
  },

  /**
   * Form validation rules
   */
  validations() {
    let output = {
      Name: {
        required,
        minLength: minLength(2),
      },
    }
     return {
      mExportGroup: output,
    }
  },

  computed: {
    nameErrors() {
      const errors = []
      if (!this.$v.mExportGroup.Name.$dirty) return errors
      !this.$v.mExportGroup.Name.required &&
        errors.push(this.$t('Form.InputErrors.Required'))
      !this.$v.mExportGroup.Name.minLength &&
        errors.push(this.$t('Form.InputErrors.minLength', { minLength: 2 }))
      return errors
    },
  },

  created() {
    if (this.exportgroup) {
    this.mExportGroup = JSON.parse(JSON.stringify(this.exportgroup))
    }
  },

  methods: {
    editExportgroup() {
      let self = this

      this.$v.$touch()
        if (this.$v.$invalid) {
          // 'ERROR'
        self.isSaving = false
        } else {
      self.isSaving = true

      exportgroupProvider.methods
        .editExportgroups(this.mExportGroup.Id, this.mExportGroup.Name)
        .then(response => {
          if (response.status === 200) {
            self.isSavingSuccess = true

            setTimeout(() => {
              self.$emit('exportNameUpdated', response.data)
              this.onClickCancel()
            }, 1500)
          }
        })
        .catch(error => {
          self.isSavingError = true
        })
        .finally(() => {
          self.isSaving = false
        })
      }
    }
  }
}
</script>
